import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {

  MainData: any;
  currentYear: any;
  constructor(private appService: AppService) { }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    this.appService.getClientBasics().subscribe((response: any) => {
      if (response && response.data) {
        this.MainData = response.data;
      }
    });
  }
}
